import { render } from "./product-list.vue?vue&type=template&id=3892e2fd&scoped=true"
import script from "./product-list.vue?vue&type=script&lang=js"
export * from "./product-list.vue?vue&type=script&lang=js"

import "./product-list.vue?vue&type=style&index=0&id=3892e2fd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3892e2fd"]])

export default __exports__